import React from "react";
import { Card } from "primereact/card";
import PropTypes from "prop-types";
import useEntityOnboarding from "../useEntityOnboarding";
import SlidingSwitch from "../../../components/SlidingSwitch/index";
import "../entityonboard.scss";

const ActiveServices = ({
  selectedservices,
  setSelectedServices,
  setEntityPlusData,
  entityPlusServiceId,
}) => {
  const { entityservices } = useEntityOnboarding();

  const handleSwitchChange = (id) => {
    if (selectedservices.includes(id)) {
      if (id === entityPlusServiceId) setEntityPlusData({});
      selectedservices = selectedservices.filter((service) => service !== id);
    } else {
      selectedservices = [...selectedservices, id];
    }
    setSelectedServices(selectedservices);
  };

  return (
    <div className="grid">
      <div className="col-12">
        <p className="general-info">Active Services.</p>
        <p className="general-info-para">
          Select all contracted services for this entity.
        </p>
      </div>
      {entityservices?.map((x) => (
        <div
          className="col-6 lg:col-6 md:col-12 sm:col-12 xs:col-12"
          key={x.id}
        >
          <Card
            className="p-card p-component"
            style={{
              border: "1px solid #ddd",
              boxShadow: "none",
              padding: 15,
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div className="flex justify-content-between align-items-center mb-2">
              <div
                className="service__icon__container"
                style={{
                  backgroundColor: x?.secondary_color,
                }}
                dangerouslySetInnerHTML={{ __html: x.icon }}
              />
              <SlidingSwitch
                checked={selectedservices.includes(x.id)}
                onChange={() => handleSwitchChange(x.id)}
              />
            </div>
            <h3 className="m-0">
              <b>{x.name}</b>
            </h3>
            <p className="mt-2">{x.description}</p>
          </Card>
        </div>
      ))}
    </div>
  );
};

ActiveServices.propTypes = {
  selectedservices: PropTypes.array,
  setSelectedServices: PropTypes.func,
};

export default ActiveServices;
